import { IInventoryPage } from '../../../inventory-page.interface';


export const UPLOAD_UPLOAD_ACCOUNTS_TEMPLATES_PAGE: IInventoryPage = {
	'route': '/upload/upload/accounts-templates',
	'title': 'Accounts & Templates',
	'uiReference': [
		'Name',
		'Short Description',
		'Mail / User',
		'Password',
		'Accounts',
		'Add',
		'Info',
		'Description',
		'Login',
		'Digital Vault',
		'Email or Username required',
		'Password required',
		'The data is stored within your private digital vault, it can only be accessed with your Vault-Key.',
		'In order to access your vault, enter your private Vault-Key in the settings here .',
		'Templates',
		'Templates exist for almost all platform but not for Displate.',
		'Please add some templates to your account to enabling uploading.',
		'Create template groups to insert multiple templates by one click, create groups here .',
		'By clicking on Save Changes all your currently edited data will be saved.',
		'Save Changes',
		'Vault Closed',
		'Platform'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/upload/upload-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/upload/accounts-templates/accounts-templates.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/upload/accounts-templates/accounts-templates.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/upload/accounts-templates/accounts-templates.component.html'
	],
	'aliases': []
};
